export enum PipelineActivityType {
  SavedQuote = "SavedQuote",
}

export interface ActivityModel {
  actitivityTypeId: PipelineActivityType;
  activityTypeName: string;
  activityTime: string;
}
